import React from "react";
import All from "./components/All";

const App = () => {
  return (
    <div>
      <All />
    </div>
  );
};

export default App;
